export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const ACTIVE_CURRENCY_CODE_UPDATED = 'ACTIVE_CURRENCY_CODE_UPDATED';
export const CUSTOMER_CURRENCY_CODE_RECEIVED = 'CUSTOMER_CURRENCY_CODE_RECEIVED';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';
export const PUBLIC_FEATURE_FLAGS_RECEIVED = 'PUBLIC_FEATURE_FLAGS_RECEIVED';
export const ADD_TO_COMPARE_PRODUCTS = 'ADD_TO_COMPARE_PRODUCTS';
export const ADD_ALL_TO_COMPARE_PRODUCTS = 'ADD_ALL_TO_COMPARE_PRODUCTS';
export const REMOVE_FROM_COMPARE_PRODUCTS = 'REMOVE_FROM_COMPARE_PRODUCTS';
export const UPDATE_TO_COMPARE_PRODUCTS = 'UPDATE_TO_COMPARE_PRODUCTS';